module.exports = __webpack_public_path__ + "media/Instruction_B41.98ecfd01.mp3";